import { render, staticRenderFns } from "./SalesOrderList.vue?vue&type=template&id=f8048daa&scoped=true&"
import script from "./SalesOrderList.vue?vue&type=script&lang=js&"
export * from "./SalesOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderList.vue?vue&type=style&index=0&id=f8048daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8048daa",
  null
  
)

export default component.exports